import React from "react";
import Container from 'react-bootstrap/Container';

import {BreadcrumbItem, Breadcrumb, Col} from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom';


const LibraryHours  = () =>{
  
  return (
    <div className="LibraryHours">
    
    <section className="inner-banner banner-align">
      <img className="img-fluid" src="./assets/img/innerbanner/libraryhours.jpg" alt=""/>
    </section>
    <section  className="research-box-area">
         <Container>
         <Breadcrumb>
                <BreadcrumbItem>
                    <Link as={Link} to="/">
                    Home
                    </Link>
                </BreadcrumbItem>
                {/* <BreadcrumbItem active>About</BreadcrumbItem> */}
                <BreadcrumbItem>
                    <Link as={Link} to="/About">
                    About
                    </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>Library Hours</BreadcrumbItem>
            </Breadcrumb>

            <div className='information-content'>
              <h2>Library Hours</h2>
              {/* <p>THe HU LICS has access to the following online research databases:</p> */}
            </div>
            <Row className=" py-4">
                <Col lg={4} className="">
                  <div className="research-box">
                    <h5>During Semester</h5>
                    <p>Monday to Friday: <b> 8:00 AM to 7:30 PM</b></p>
                    {/* <p>Working Saturdays:<b> 9:00 AM to 5:00 PM</b></p>                     */}
                  </div>
                </Col>
                
                <Col lg={4} className="border-end border-start">
                <div className="research-box">
                    <h5>Working Saturdays</h5>
                    <p><b> 8:00 AM to 5:00 PM</b></p>  
                  </div>
                </Col>
                <Col lg={4} className="">
                <div className="research-box">
                    <h5>During Summer and Winter break</h5>
                    <p>Monday to Friday:<b> 9:00 AM to 5:00 PM</b></p> 
                  </div>
                </Col>
               
            </Row>
         </Container>
    </section>
    {/* <section  className="research-box-area">
         <Container>
            <div className='information-content'>
              <h2>Library Hours</h2>
              <p>During Semester Library Hours are from  Monday to Friday 8:00 a.m. to 6:30 p.m. and 9:00 a.m. to 5:00 p.m. on working Saturdays. The library hours during the summer and winter break are from 9:00 a.m. to 5:00 p.m.</p>
            </div>
         </Container>
    </section> */}
   
  </div>
  );
}
export default LibraryHours ;